import { common, grey } from '@material-ui/core/colors';

const greyscale = Object.assign( {}, grey, {
    black: common.black,
    white: common.white,
} );
export default greyscale;
